import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryCards from './components/CategoryCards';
import FeaturedArticles from './components/FeaturedArticles';
import LatestNews from './components/LatestNews';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryCards />
        <FeaturedArticles />
        <LatestNews />
      </main>
      <Footer />
    </>
  );
}